import api from "@/lib/api";

const KEY = "ns_anon_diag";

export function setAnonDiag(id) {
  const d = new Date();
  d.setTime(d.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days
  document.cookie = `${KEY}=${id};expires=${d.toUTCString()};path=/;SameSite=Lax`;
}

export function getAnonDiag() {
  const m = document.cookie.match(new RegExp("(^| )" + KEY + "=([^;]+)"));
  return m ? m[2] : null;
}

export function clearAnonDiag() {
  document.cookie = `${KEY}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
}

// Best-effort: attach a completed anonymous diagnostic to a freshly created
// parent account, creating one child + their learning plan. Clears the cookie
// on success. Returns the new student id, or null if nothing to attach.
export async function attachAnonDiag(childName) {
  const sessionId = getAnonDiag();
  if (!sessionId) return null;
  try {
    const { data } = await api.post(`/public/diagnostic/${sessionId}/attach`, {
      child_name: childName || "",
    });
    clearAnonDiag();
    return data.student_id || null;
  } catch (e) {
    // Only drop the session if it's genuinely unusable (used/expired/not a parent).
    // Keep it on transient/network errors so a retry can still attach it.
    const status = e.response?.status;
    if (status === 400 || status === 403 || status === 404) clearAnonDiag();
    return null;
  }
}
